import React, { createContext, useContext } from "react";
import useSWR from "swr";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);
const fetcher = (url) => api.get(url).then((r) => r.data);

const FALLBACK = {
  company: { name: "Belov Multiservice", cvr: "46631307", email: "wellbellov@gmail.com", phone: "+45 22 21 56 44", address: "", city: "København" },
  service_available: true,
  hero_tagline: {
    da: "Har du fået leveret dine IKEA-møbler? Vi klarer monteringen.",
    en: "Got your IKEA furniture delivered? We'll take care of the assembly.",
  },
};

export function SettingsProvider({ children }) {
  const { data } = useSWR("/settings/public", fetcher, { revalidateOnFocus: false });
  return <SettingsContext.Provider value={data || FALLBACK}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext) || FALLBACK;
}
